import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";

const url = GlobalConstants.urlApi;

export const referenciasService = {
    getAllReferencias,
    getReferenciaById,
    setStateReferenciaById,
    crudReferencias,
    getTipoActivos,
    getReferencias,
    getMarcas,
    getPropietarios,
    getSubPortafolios,
    getFrecuencias,
    getFilteredData
};

async function getAllReferencias() {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    let res = await fetch(`${url}/referencias/getAllReferencias`, requestOptions)
    return res.json()
}

function getReferenciaById(codigo) {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/referencias/getReferenciaById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function crudReferencias(data) {
    // loaderService.showLoader({label: "Cargando..."});

    const formData = new FormData();

    console.log(data?.imagen)
    if (data?.imagen !== undefined) {
        console.log(data, 'dentro')
        formData.append('IMG', data.imagen, data.imagen?.name);
    }

    formData.append('data', JSON.stringify(data));
    formData.append('app', 'maestros');
    formData.append('interface', 'referencias');

    const requestOptions = {
        method: 'POST',
        headers: {
          'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/referencias/crudReferencias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setStateReferenciaById(data) {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/referencias/setStateReferenciaById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTipoActivos(data) {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data: data})
    };

    return fetch(`${url}/referencias/getTipoActivos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getReferencias() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/referencias/getReferencias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getMarcas() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/referencias/getMarcas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPropietarios() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/referencias/getPropietarios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSubPortafolios() {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/referencias/getSubPortafolios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getFrecuencias() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/referencias/getFrecuencias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getFilteredData(data) {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/referencias/getFilteredData`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}








